/**
 * NotFound — the "*" catch-all. Honest 404: a breadcrumb + one H1 + a warning message + a SkyLink home.
 * No blank route ever.
 */
import { SkyMessageBar, SkyLink } from "@skypointcloud/skypoint-ui";
import { PageHeader } from "../shell/PageHeader";
import { PageFooter } from "../shell/PageFooter";

export function NotFound() {
  return (
    <>
      <PageHeader
        crumbs={[{ key: "home", label: "skyCare", to: "/" }, { key: "not-found", label: "Not found" }]}
        title="Page not found"
        description="The requested route does not exist."
      />
      <section className="mt-6 flex-1">
        <SkyMessageBar
          intent="warning"
          title="Not found"
          message="No screen matches this address."
        />
        <div className="mt-4">
          <SkyLink href="/">Go to the dashboard</SkyLink>
        </div>
      </section>
      <PageFooter />
    </>
  );
}
